import { render, staticRenderFns } from "./SearchResultsView.vue?vue&type=template&id=607e6666&"
import script from "./SearchResultsView.vue?vue&type=script&lang=ts&"
export * from "./SearchResultsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports